import { IconButton, Tooltip } from '@material-ui/core';
import { Hue } from 'annotation-tools/utils';
import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { hueToDefaultHex } from '../../../../functions/hue-to-hex';

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  width: 120px;
  height: 24px;
  border-radius: 12px 12px 12px 12px;
  color: white;
`;

interface Props {
  mode: 'edit' | 'view';
  id: number;
  hue: Hue;
  changeLabelColor: (id: number, colorCode: string) => void;
}

export const LabelColorCell: FC<Props> = memo(
  ({ mode, id, hue, changeLabelColor }: Readonly<Props>) => {
    const handleSelect = (colorCode: string) => {
      changeLabelColor(id, colorCode);
    };

    const colors = {
      '#e61d19': '1(Red)', //1
      '#e67919': '2(Orange)', //28
      '#e6a519': '3(Bright Orange)', //41
      '#e6df19': '4(Yellow)', //58
      '#a1e619': '5(LimeGreen)', //80
      '#42e619': '6(Green)', //108
      '#19e5e6': '7(SkyBlue)', //180
      '#19ace6': '8(CeruleanBlue)', //197
      '#1946e6': '9(Blue)', //227
      '#6819e6': '10(Violet)', //263
      '#b319e6': '11(Purple)', //285
      '#e219e6': '12(Pink)' //299
    };
    return (
      <Root>
        <Box style={{ backgroundColor: hueToDefaultHex(hue) }}>
          <span style={{ verticalAlign: 'middle' }}>
            {colors[hueToDefaultHex(hue)]}
          </span>
        </Box>
        {mode === 'edit' ? (
          <div style={{ flex: '1', maxWidth: '350px', margin: '20px' }}>
            {Object.keys(colors).map(color => (
              <Tooltip title={colors[color]} key={color}>
                <IconButton
                  style={{ backgroundColor: color, margin: '2px' }}
                  onClick={() => handleSelect(color)}
                  key={color}
                />
              </Tooltip>
            ))}
          </div>
        ) : (
          undefined
        )}
      </Root>
    );
  }
);

LabelColorCell.displayName = 'LabelColorCell';
